<template>
  <van-popup
    v-if="backoffice.contesto !== 'cassaFlutter'"
    :value="showDialog"
    :position="position"
    class="main-popup-backoffice"
    :style="stileDialog"
    :close-on-click-overlay="true"
    @opened="openPopup"
    @click-close-icon="closeDialog"
    @click-overlay="closeDialog"
  >
    <iframe
      :src="urlBackoffice"
      scrolling="no"
      :style="stileFrame"
      id="backIframe"
    ></iframe>
    <van-button
      v-if="backoffice.contesto !== 'cassaFlutter'"
      type="info"
      plain
      style="position:fixed; left: auto; right:10px; top: auto; bottom:10px;"
      @click="closeDialog"
      >{{ labelChiusura }}</van-button
    >
  </van-popup>
</template>

<script>
/* eslint-disable */
import configurazioni from "@/services/configurazioniService";
import _ from "lodash";
import mqtt from "../../../mqtt";
export default {
  props: {
    show: Boolean,
    context: Object
  },
  data() {
    return {
      source: "",
      showDialog: false,
      xDialog: 100,
      yDialog: 100,
      xFrame: 100,
      yFrame: 100,
      position: "left"
    };
  },
  watch: {
    async show(value) {
      if (value) {
        await this.apriBackoffice();
        this.showDialog = true;
      }
    }
  },
  async mounted() {
    mqtt.events.close.on((id, payload) => {
      const payloadJson = JSON.parse(payload);
      if (payloadJson.clientId !== "CASSA_VUE") {
        this.closeDialogCassaFlutter(payloadJson.payload, id);
      }
    });
    mqtt.events.pagamenti.on((id, payload) => {
      const payloadJson = JSON.parse(payload);
      if (
        payloadJson.clientId !== "CASSA_VUE" &&
        payloadJson.payload.prodotti
      ) {
        console.log("arrivano prodotti");
        this.closeDialogCassaFlutter(payloadJson.payload, id);
      }
    });
    mqtt.configurations.keyboard.on((id, payload) => {
      const payloadJson = JSON.parse(payload);
      if (payloadJson.clientId !== "CASSA_VUE") {
        console.log("arriva barcode");
        this.inviaBarcode(payloadJson.payload);
      }
    });
  },
  beforeUnmounted() {
    mqtt.events.close.popListener();
  },
  computed: {
    baseUrl() {
      const baseEnv = this.$route.query.url || "";
      return baseEnv || this.impostazioni.baseUrl || "http://localhost:8081";
    },
    backoffice() {
      return this.context.backoffice;
    },
    chiave() {
      return this.backoffice.chiave || "cassa01";
    },
    impostazioni() {
      return this.context.impostazioni.backoffice || {};
    },
    urlBackoffice() {
      console.log(`${this.baseUrl}/${this.source}`);
      return (
        this.backoffice.url ||
        (this.source ? `${this.baseUrl}/${this.source}` : "")
      );
    },
    stileDialog() {
      return `width:${this.xDialog}%; height:${this.yDialog}%`;
    },
    stileFrame() {
      return `width:${this.xFrame}vw; height:${this.yFrame}vh`;
    },
    labelChiusura() {
      return this.impostazioni.labelChiusura || "OK";
    }
  },
  methods: {
    openPopup() {},
    async apriBackoffice() {
      var fattore, chiave, payload, prodotto;
      this.position = "left";
      const contesto = this.backoffice.contesto;
      console.log("apriBackoffice", contesto);
      // const comando = contesto.comando
      // let urlPagina = ''
      switch (contesto) {
        case "fattureElettroniche":
          this.source = "cassa/fatture-elettroniche";
          this.xDialog = 100;
          this.yDialog = 100;
          this.xFrame = 100;
          this.yFrame = 100;
          break;
        case "cassaFlutter":
          if (this.context.idScontrino === "") {
            mqtt.events.open.publish(
              { clientId: "CASSA_VUE" },
              { qos: 0, retain: false }
            );
            const event = {
              type: "APERTURA_CASSA_FLUTTER"
            };
            this.$emit("send-event", event);
          } else this.azzeraScontrino();
          this.source = this.backoffice.url;
          break;
        case "menuComposto":
          chiave = `menuTotali_${this.chiave}`;
          payload = {
            menuTotali: this.context.menuTotali
          };
          await configurazioni.setMemoriaCondivisa(chiave, payload);
          this.source = `cassa/menu-composti/${this.backoffice.menu}/${this.chiave}`;
          this.xDialog = 100;
          this.yDialog = 100;
          this.xFrame = 100;
          this.yFrame = 100;
          break;
        case "dettaglioCliente":
          fattore = 1.2;
          if (window.innerWidth < 1600) fattore = 1.5;
          if (window.innerWidth < 1400) fattore = 2;
          this.xDialog = 50 * fattore;
          this.yDialog = 100;
          this.xFrame = 50 * fattore;
          this.yFrame = 100;
          this.source = `cassa/clienti/dettaglio/${this.backoffice.idCliente}`;
          break;
        case "variazioni":
          prodotto = this.context.rigaCarrello;
          if (this.context.rigaSelezionata !== null) {
            prodotto = _.get(
              this.context,
              "righeCarrello[" + this.context.rigaSelezionata + "]",
              ""
            );
          }
          fattore = 1.2;
          if (window.innerWidth < 1600) fattore = 1.5;
          if (window.innerWidth < 1400) fattore = 2;
          this.xDialog = 30 * fattore;
          this.yDialog = 100;
          this.xFrame = 30 * fattore;
          this.yFrame = 100;
          this.position = "right";
          payload = {
            prodotto: prodotto
          };
          console.log("setMemoriaCondivisa", this.chiave, payload);
          await configurazioni.setMemoriaCondivisa(this.chiave, payload);
          this.source = `cassa/variazioni/${prodotto.codice}/${this.chiave}`;
          console.log("source", this.source);
          break;
        case "buoniPasto":
          fattore = 1.2;
          if (window.innerWidth < 1600) fattore = 1.5;
          if (window.innerWidth < 1400) fattore = 2;
          this.xDialog = 36 * fattore;
          this.yDialog = 100;
          this.xFrame = 36 * fattore;
          this.yFrame = 100;
          this.position = "right";
          payload = {};
          await configurazioni.setMemoriaCondivisa(this.chiave, payload);
          this.source = `cassa/buoni-pasto/${this.chiave}`;
          break;
        case "lavorazioni":
          fattore = 2.5;
          if (window.innerWidth < 1600) fattore = 3;
          if (window.innerWidth < 1400) fattore = 3.3;
          this.xDialog = 30 * fattore;
          this.yDialog = 100;
          this.xFrame = 30 * fattore;
          this.yFrame = 100;
          this.position = "right";
          payload = {
            idScontrino:
              this.backoffice.comando === "carica"
                ? this.context.idScontrino
                : null
          };
          console.log("setMemoriaCondivisa", this.chiave, payload);
          await configurazioni.setMemoriaCondivisa(this.chiave, payload);
          this.source = `cassa/lavorazioni/${this.chiave}`;
          console.log("source", this.source);
          break;
        case "scambioDati":
          /*           prodotto = this.context.rigaCarrello
          if (this.context.rigaSelezionata !== null) {
            prodotto = _.get(this.context, 'righeCarrello[' + this.context.rigaSelezionata + ']', '')
          } */
          fattore = 1.2;
          if (window.innerWidth < 1600) fattore = 1.5;
          if (window.innerWidth < 1400) fattore = 2;
          this.xDialog = 30 * fattore;
          this.yDialog = 100;
          this.xFrame = 30 * fattore;
          this.yFrame = 100;
          this.position = "right";
          payload = {
            avviaAutomatiche: true // Fa avviare le esportazioni definite come "automatiche"
          };
          console.log("setMemoriaCondivisa", this.chiave, payload);
          await configurazioni.setMemoriaCondivisa(this.chiave, payload);
          this.source = `cassa/scambiodati/${this.chiave}`;
          console.log("source", this.source);
          break;
        default:
          break;
      }
    },
    async closeDialog() {
      console.log("closeDialog");
      this.showDialog = false;
      this.source = ""; // TODO: Verificare senza (riapre più velocemente la stessa. Cosa succede se diversa ?)

      // TODO: Verificare quale lasciare
      const payload = await configurazioni.takeMemoriaCondivisa(this.chiave);
      let chiave = `menuTotali_${this.chiave}`;
      const totali = await configurazioni.takeMemoriaCondivisa(chiave);
      chiave = `lavorazione_${this.chiave}`;
      const lavorazioni = await configurazioni.takeMemoriaCondivisa(chiave);
      // console.log('condivisa', condivisa)
      // this.$emit('close', condivisa)
      const event = {
        type: "BACKOFFICE_RETURN",
        backoffice: this.backoffice,
        payload: payload,
        menuTotali: totali,
        lavorazioni
      };
      this.$emit("send-event", event);
    },
    async closeDialogCassaFlutter(payload, idTavolo) {
      console.log("closeDialog");
      this.showDialog = false;
      this.source = ""; // TODO: Verificare senza (riapre più velocemente la stessa. Cosa succede se diversa ?)

      const event = {
        type: "BACKOFFICE_RETURN_RISTORAZIONE",
        backoffice: this.backoffice,
        prodotti: payload?.prodotti,
        idTavolo,
        noMovimenti: payload?.prodotti.some(
          prodotto => prodotto.codice === "prodotto_unico"
        )
      };
      this.$emit("send-event", event);
    },
    async inviaBarcode(barcode) {
      const event = {
        // type: 'ENTER'
        type: "ADD_BARCODE",
        code: barcode
      };
      this.$emit("send-event", event);
    },
    async azzeraScontrino() {
      const event = {
        type: "ANNULLA_SCONTRINO"
      };
      this.$emit("send-event", event);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../popup.scss";
/*
    Invece della classe fissa utilizzo stile calcolato, in modo da poter cambiare per ogni finestra
  */
.main-popup-backoffice {
  width: 100%;
  height: 100%;
}

.van-popup {
  border-radius: 0 !important;
}

iframe {
  display: block; /* iframes are inline by default */
  background: white;
  border: none; /* Reset default border */
  /* height: 100vh; */ /* Viewport-relative units */
  /* width: 100vw; */
}
</style>
